import { useQuery } from "@apollo/client";
import { CURRENT_USER } from "../graphql/queries";
import { ICurrentUserOutput } from "../graphql/types/queries/user";

export const useMe = () => {
  const { data:dataMe, error:errorMe, loading:loadingMe } = useQuery<ICurrentUserOutput>(CURRENT_USER);

  return {
    session: dataMe,
    errorMe,
    loadingMe
  };
};
